export default "__VITE_ASSET__3b0049f5__"